import ViewBenefitsPage from "components/viewBenefits/ViewBenefits.component"

const ViewBenefits = () => {
  return (
    <ViewBenefitsPage />
  )
}

export default ViewBenefits
